<div class="dasboard-width" >
  <div class="row header mar-lft-rgt-0">
    <div class="col-sm-3 pad-0">
      <div class="page-title" style="margin: 0px 0px;">
        <ol class="breadcrumb no-background">
          <li class="active"><i class="fa fa-tachometer"></i> <span class="blue">i</span><span class="red">FIX</span>
            Dashboard
          </li>
        </ol>
      </div>
    </div>
    <div class="col-sm-3">
      <mat-form-field [hidden]="!(isLabel1 && islead)">
        <mat-label>User:</mat-label>
        <mat-select [(ngModel)]="userSelected" (selectionChange)="onSelectUser()">
          <mat-option *ngFor="let user of users" [value]="user.id"
          >{{user.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-sm-3">
      <mat-form-field [hidden]="!(isLabel1 && islead) && !isLabel2">
        <mat-label>Category:</mat-label>
        <mat-select [(ngModel)]="categorySelected" (selectionChange)="onSelectCategory()">
          <mat-option *ngFor="let category of categories" [value]="category.id"
          >{{category.name}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="col-sm-3">
      <mat-form-field>
        <mat-label>Current Role:</mat-label>
        <mat-select [(ngModel)]="userGroupSelected" (selectionChange)="onSelectGroup()" class="matSize">
          <mat-option *ngFor="let group of userGroups" [value]="group.groupId" class="matOptionSize"
          >{{group.grpName}}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  <ng-template #content let-c="close" let-d="dismiss">
<!--    <div class="modal-body">-->
<!--      <app-chart></app-chart>-->
<!--    </div>-->
  </ng-template>
  <div class="dashboard-content mr-top-5">
    <div class="row mar-lft-rgt-0 font-16">
      <div class="col-sm-10 pad-15">
        <div class="height-40" [hidden]="ticketTypeLoaded">
          <img class="loading-gif-42" src="../../../assets/img/loader-42px.gif">
        </div>
        <mat-radio-group (change)="onButtonChange($event)" [hidden]="!ticketTypeLoaded">
          <!--<div *ngFor="let button of radioButton;">-->
          <mat-radio-button *ngFor="let button of radioButton;" [value]="button"
                            [checked]="button.checked">{{button.name}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</mat-radio-button>&nbsp;&nbsp;
          <!--</div>-->
        </mat-radio-group>
      </div>
      <div class="col-sm-2 pad-15">
        <!--font-13 radius-0-->
        <button type="button" class="btn btn-warning radius-0 refresh-btn matRipple right" (click)="onPageLoad()" title="refresh"> <mat-icon>refresh</mat-icon></button>
      </div>
    </div>
    <ng-template #content let-c="close" let-d="dismiss">
<!--      <div class="modal-body">-->
<!--        <app-chart [chartRadius]="radius" ></app-chart>-->
<!--      </div>-->
    </ng-template>
    <div class="row mar-lft-rgt-0">
      <!--<div class="col-md-3 col-sm-6 chartBox mr-lft-5" (click)="chartDetails()">-->
        <!--<div class="chart-style">-->
            <!--<app-chart *ngIf="hideChart" [chartRadius]="radius"></app-chart>-->
          <!--</div>-->
      <!--</div>-->

      <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="!isLabel0 && !isLabel1">
        <div class="card card-style create-ticket-bg shadow border-0 pointer" matRipple (click)="createTicket()">
          <div class="card-body pad-0">
            <h1 class="card-text static-card">Create Ticket</h1>
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="!isLoading">
        <div class="card card-style shadow border-0">
          <div class="card-body pad-0">
            <img class="loading-gif-70" src="../../../assets/img/loader-70px.gif">
          </div>
        </div>
      </div>
      <div class="col-md-2 col-sm-3 mar-top-15" *ngFor="let data of tilesData" (click) = "goto(data.fid)">
        <div class="card card-style half shadow border-0 pointer" matRipple>
          <div class="card-top" [ngStyle]="{'background-color': data.color_code}">

            <h4 class="card-text top-part top-tesxtarea">{{data.funcDescription}}
              <mat-icon color="black" class="none" id="display_{{data.fid}}">grade</mat-icon>
            </h4>
          </div>
          <div class="card-buttom">
            <img id="loader_{{data.fid}}" src="../../../assets/img/elipsis_loader.gif">
            <h1 class="card-text buttom-number" id="count_{{data.fid}}"></h1>
          </div>
        </div>
      </div>


      <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="!isLabel1 && !islead">
        <!-- <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="!isLabel0 && !isLabel1 && !isLabel2 && !islead"> -->
        <div class="card card-style bulk-bg shadow border-0 pointer" matRipple (click)="goToBulkAssigment()">
          <div class="card-body pad-0">
            <h1 class="card-text static-card">Bulk Assignment</h1>
          </div>
        </div>
      </div>


      
      <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="!isLabel0 && !isLabel1 && !isLabel2 && !islead">
        <div class="card card-style search-bg shadow border-0 pointer" matRipple (click)="goToSearch()">
          <div class="card-body pad-0">
            <h1 class="card-text static-card">Search Ticket</h1>
          </div>
        </div>
      </div>

      <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="!isLabel0 && !isLabel1 && !isLabel2 && !islead">
        <div class="card card-style faq-bg shadow border-0 pointer" matRipple (click)="goTofaq()">
          <div class="card-body pad-0">
            <h1 class="card-text static-card">FAQ</h1>
          </div>
        </div>
      </div>

      <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="!isLabel0 && !isLabel1 && !isLabel2 && !islead">
        <div class="card img-style img-bg shadow border-0 pointer" matRipple>
          <div class="card-body pad-0">
            <img src="../../assets/img/Call.jpg" height="150" width="160" >
          </div>
        </div>
      </div>

      <!-- <div class="col-md-2 col-sm-3 mar-top-15" [hidden]="!isLabel0 && !isLabel1 && !isLabel2 && !islead">
        <div class="card img-style img-bg shadow border-0 pointer" matRipple>
          <div class="card-body pad-0">
            <img src="../../assets/img/ChatWithIRA.png" height="150" width="160" class="staticImg">
          </div>
        </div>
      </div> -->

    </div>
  </div>
</div>
